import classNames from 'classnames';
import React, { FC } from 'react';

import { Icon, IconTypes } from '@eika/icon';

import { MenuItem } from '../MenuTypes';

export interface MenuElement {
    menuItem: MenuItem;
    className?: string;
}

const MenuElement: FC<MenuElement> = ({ menuItem, className }) => {
    const { link, isExternalLink, name, isActive } = menuItem;
    return (
        <li
            role="menuitem"
            className={classNames('menu__item', { active: isActive, 'is-external': isExternalLink }, className)}
        >
            <a href={link.url} target={isExternalLink ? '_blank' : '_self'} rel="noopener noreferrer">
                {name}
                {isExternalLink && <Icon type={IconTypes.ExternalLink} />}
            </a>
        </li>
    );
};

export default MenuElement;
